<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">
        <app-filtro
          :fechaDesde="fechaDesdeParam"
          :fechaHasta="fechaHastaParam"
          :proveedor="proveedor"
          :sortByDescending="sortByDescending"
          @filtrar="filtrar">
        </app-filtro>  
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card header="Registro de Evaluaciones">
          <b-table hover
              responsive="sm" 
              class="registro"
              :busy="tableBusy"
              :items="evaluacionesProveedores" 
              :fields="evaluacionesProveedoresFields" 
              @row-clicked="consultar">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>              
            <template v-slot:cell(fechaEvaluacion)="data">
              {{ data.item.fechaEvaluacion | fecha }}
            </template>
            <template v-slot:cell(calificacion)="data">
              {{ data.item.calificacion | numero(2, true) }}
            </template>
            
            <template v-slot:cell(opciones)="data">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item 
                    :disabled="!borradoHabilitado(data.item)"
                    @click.stop="borrarItem(data.item)">
                  <i class="fa fa-remove"></i>Borrar Evaluación</b-dropdown-item>
                
                <!-- <b-dropdown-item @click.stop="actualizarStock(data.item)">
                  <i class="fa fa-edit"></i>Actualizar Stock</b-dropdown-item> -->
              </b-dropdown>
            </template>
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
            <label class="pagination-description">{{ paginacion }}</label>
          </nav>
        </b-card>
        </transition>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          <b-dropdown-item
              @click.stop="exportXls">
            <i class="fa fa-file-excel-o"></i>Exportar Listado de Evaluaciones</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Filtro from './listFiltro.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';
import moment from 'moment';

const { mapFields } = createHelpers({
  getterType: 'evaluacionesProveedores/getField',
  mutationType: 'evaluacionesProveedores/updateField',
});

export default {
  name: 'EvaluacionesProveedoresList',
  components: {
    appFiltro: Filtro,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [
    msjModal, 
    confirmModal, 
  ],
  data: () => {
    return {
      evaluacionesProveedoresFields: [
        {
          key: 'fechaEvaluacion',
        },
        { key: 'proveedor' },
        { 
          key: 'referenciaNumero',
          label: 'Nro.Orden / Nro.Remito' 
        },
        { key: 'referencia' },
        // { 
        //   key: 'presupuestoNumero',
        //   label: 'Nro.Presupuesto' 
        // },
        // { key: 'presupuestoInterno' },
        { 
          key: 'calificacion',
          class: 'text-right' 
        },
        { key: 'usuario' },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],

      tableBusy: false,
      opcionBorrarEvaluacion: false
    }
  },
  computed: {
    ...mapFields([
      'evaluacionesProveedores',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',
      'fechaDesde',
      'fechaHasta',
      'proveedor',
      'sortByDescending'
    ]),
    usuarioId() {
      return parseInt(this.$store.getters['user/userId']);
    },
    fechaDesdeParam() {
      return moment(this.fechaDesde).format('YYYY-MM-DD');
    },
    fechaHastaParam() {
      return moment(this.fechaHasta).format('YYYY-MM-DD');
    },
    paginacion() {
      let paginaActual = 0;
      let registrosPorPagina = 0;
      let totalPaginas = 0;
      let totalRegistros = 0;
      let registroDesde = 0;
      let registroHasta = 0;

      if (this.paginaActual) {
        if (!isNaN(this.paginaActual)) {
          paginaActual = parseInt(this.paginaActual);
        }
      }
      if (this.registrosPorPagina) {
        if (!isNaN(this.registrosPorPagina)) {
          registrosPorPagina = parseInt(this.registrosPorPagina);
        }
      }
      if (this.totalPaginas) {
        if (!isNaN(this.totalPaginas)) {
          totalPaginas = parseInt(this.totalPaginas);
        }
      }
      if (this.totalRegistros) {
        if (!isNaN(this.totalRegistros)) {
          totalRegistros = parseInt(this.totalRegistros);
        }
      }
      if (totalPaginas == 0) {
        totalPaginas = 1;
      }
      registroDesde = ((paginaActual - 1) * registrosPorPagina) + 1;
      if (registroDesde > totalRegistros) {
        registroDesde = totalRegistros;
      }
      registroHasta = registroDesde + registrosPorPagina - 1;
      if (registroHasta > totalRegistros) {
        registroHasta = totalRegistros;
      }

      return `Pág. ${paginaActual} de ${totalPaginas} - Registros ${registroDesde} a ${registroHasta} de ${totalRegistros} registros`;
    }
  },
  created() {
    let userRolId = parseInt(this.$store.getters['user/rolId']);

    switch (userRolId) {
      case 1:
      case 2: /* Direccion */
      case 4: /* Produccion */
      case 8: /* Calidad */
      case 9: /* Director Ejecutivo */
        this.opcionBorrarEvaluacion = true;
        break;
    }

    this.getItems();
  },  
  methods: {
    filtrar(filtro) {
      this.fechaDesde = filtro.fechaDesde;
      this.fechaHasta = filtro.fechaHasta;
      this.proveedor = filtro.proveedor;
      this.sortByDescending = filtro.sortByDescending;
      this.paginaActual = 1;
      
      this.getItems();
    },
    borradoHabilitado(item) {
      if (this.opcionBorrarEvaluacion) {
        return true;
      }

      if (item.usuarioId == this.usuarioId) {
        return true;
      }

      return false;
    },
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('evaluacionesProveedores/getEvaluaciones')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },
    consultar (item) {
      this.$router.push({ name: 'EvaluacionProveedorData', 
                          params: { id: item.id }});
    },
    borrarItem (item) {
      this.showModalConfirm('¿Desea borrar la evaluación seleccionada?', 
            this.borrar.bind(this, item.id), 'Si', null, 'No')
    },
    borrar (evaluacionProveedorId) {
      this.showSpinner();
      this.$store.dispatch('evaluacionesProveedores/delete', evaluacionProveedorId)
        .then(() => this.showModalMsj('La evaluación se borró con éxito', this.getItems, this.getItems, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    exportXls () {
      this.showSpinner();
      this.$store.dispatch('evaluacionesProveedores/getList')
        .then(() => {
          let exportList = Boolean(false); 
          let list = this.$store.getters['evaluacionesProveedores/list'];

          if (list) {
            if (list.length != 0) {
              exportList = Boolean(true);
            }
          }
          if (exportList) {
            let title= 'Listado de Evaluaciones';
            let fileName = 'evaluaciones-proveedores';
            let format = [
              { titulo: 'Fecha Evaluación', nombre: 'fechaEvaluacion', formato: 'fecha' },
              { titulo: 'Proveedor', nombre: 'proveedor', formato: '' },
              { titulo: 'Nro.Orden/Nro.Remito', nombre: 'referenciaNumero', formato: '' },
              { titulo: 'Referencia', nombre: 'referencia', formato: '' },
              { titulo: 'Calificación', nombre: 'calificacion', formato: '' },
              { titulo: 'Atención al Cliente', nombre: 'calificacionAtencionCliente', formato: '' },
              { titulo: 'Tiempo de Entrega', nombre: 'calificacionTiempoEntrega', formato: '' },
              { titulo: 'Costos', nombre: 'calificacionCostos', formato: '' },
              { titulo: 'Calidad', nombre: 'calificacionCalidad', formato: '' },
              { titulo: 'Usuario', nombre: 'usuario', formato: '' },
              { titulo: 'Observaciones', nombre: 'observaciones', formato: '' },
            ];

            this.exportXLS(title, fileName, list, format);            
          } else {
            this.showModalMsj('No hay datos para exportar', null, null, 'light')
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems();
      }
    },    
  }    
}
</script>

<style>
</style>
